// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__3YYDU","colCheckbox":"styles_colCheckbox__2eSf5"};